// Auto-generated from OLTA_deal_names.xlsx — word(lowercase) -> {topic, definition}.
export const NAME_META = {
"marlin": {
"topic": "Saltwater & Game Fish",
"definition": "A large, fast billfish prized by sport anglers. Known for spectacular leaping fights."
},
"tuna": {
"topic": "Saltwater & Game Fish",
"definition": "A powerful, warm-blooded ocean fish built for speed. Includes prized species like bluefin and yellowfin."
},
"bluefin": {
"topic": "Saltwater & Game Fish",
"definition": "The largest and most valuable tuna species. Highly sought after for sushi and sport."
},
"yellowfin": {
"topic": "Saltwater & Game Fish",
"definition": "A sleek, fast tuna with bright yellow fins. Common target for offshore anglers."
},
"mahi-mahi": {
"topic": "Saltwater & Game Fish",
"definition": "A brilliantly colored tropical fish, also called dorado. Fast-growing and acrobatic when hooked."
},
"dorado": {
"topic": "Saltwater & Game Fish",
"definition": "Another name for mahi-mahi, meaning 'golden' in Spanish. Famous for vivid green-gold color."
},
"barracuda": {
"topic": "Saltwater & Game Fish",
"definition": "A long, fierce predator with sharp teeth. Strikes lures with sudden speed."
},
"swordfish": {
"topic": "Saltwater & Game Fish",
"definition": "A large billfish with a flat, sword-like bill. A challenging deep-water game fish."
},
"sailfish": {
"topic": "Saltwater & Game Fish",
"definition": "A billfish with a huge sail-like dorsal fin. Considered the fastest fish in the ocean."
},
"tarpon": {
"topic": "Saltwater & Game Fish",
"definition": "A large silvery fish famous for leaping. A classic flats and inshore game fish."
},
"wahoo": {
"topic": "Saltwater & Game Fish",
"definition": "An extremely fast, slender ocean fish. Prized for both sport and eating."
},
"snapper": {
"topic": "Saltwater & Game Fish",
"definition": "A reef fish family valued for firm, white flesh. Red snapper is the best known."
},
"grouper": {
"topic": "Saltwater & Game Fish",
"definition": "A heavy-bodied bottom fish that ambushes prey. Popular table fish in warm waters."
},
"halibut": {
"topic": "Saltwater & Game Fish",
"definition": "A large flatfish living on the seabed. Among the biggest flatfish caught commercially."
},
"mackerel": {
"topic": "Saltwater & Game Fish",
"definition": "A small, fast schooling fish with striped backs. An oily, flavorful food and bait fish."
},
"herring": {
"topic": "Saltwater & Game Fish",
"definition": "A small silvery schooling fish. A key forage species and food fish worldwide."
},
"anchovy": {
"topic": "Saltwater & Game Fish",
"definition": "A tiny, strongly flavored saltwater fish. Often salted, cured, or used as bait."
},
"sardine": {
"topic": "Saltwater & Game Fish",
"definition": "A small oily fish often canned. Important both as food and forage."
},
"bonito": {
"topic": "Saltwater & Game Fish",
"definition": "A small tuna relative with striped sides. Used for food and as live bait."
},
"skipjack": {
"topic": "Saltwater & Game Fish",
"definition": "A small striped tuna common in canned 'light' tuna. Travels in fast schools."
},
"kingfish": {
"topic": "Saltwater & Game Fish",
"definition": "A name for king mackerel and similar fast predators. A popular sportfishing target."
},
"cobia": {
"topic": "Saltwater & Game Fish",
"definition": "A strong, solitary fish often found near buoys and wrecks. Excellent eating and sport."
},
"pompano": {
"topic": "Saltwater & Game Fish",
"definition": "A small, prized flatfish-shaped game fish. Considered a delicacy in the Gulf and Atlantic."
},
"amberjack": {
"topic": "Saltwater & Game Fish",
"definition": "A powerful reef-dwelling fish that fights hard. Common around wrecks and structure."
},
"yellowtail": {
"topic": "Saltwater & Game Fish",
"definition": "A fast amberjack relative prized in sushi. Strong fighter for sport anglers."
},
"flounder": {
"topic": "Saltwater & Game Fish",
"definition": "A flatfish that lies camouflaged on the bottom. Both eyes sit on one side of its body."
},
"sole": {
"topic": "Saltwater & Game Fish",
"definition": "A small, delicate flatfish prized in cooking. Dover sole is the classic example."
},
"plaice": {
"topic": "Saltwater & Game Fish",
"definition": "A European flatfish with orange spots. A common, mild-flavored food fish."
},
"turbot": {
"topic": "Saltwater & Game Fish",
"definition": "A large, prized flatfish with firm flesh. Highly valued in European cuisine."
},
"cod": {
"topic": "Saltwater & Game Fish",
"definition": "A cold-water bottom fish central to many fisheries. Mild white flesh and historic importance."
},
"haddock": {
"topic": "Saltwater & Game Fish",
"definition": "A cod relative with a milder, finer flesh. A staple of fish and chips."
},
"pollock": {
"topic": "Saltwater & Game Fish",
"definition": "An abundant cod relative used in processed seafood. Common in fish sticks and imitation crab."
},
"hake": {
"topic": "Saltwater & Game Fish",
"definition": "A slender cod relative living in deep water. A widely eaten white fish."
},
"snook": {
"topic": "Saltwater & Game Fish",
"definition": "A prized inshore game fish with a black lateral stripe. Popular in tropical and subtropical waters."
},
"permit": {
"topic": "Saltwater & Game Fish",
"definition": "A wary, powerful flats fish in the jack family. A trophy target for fly anglers."
},
"bonefish": {
"topic": "Saltwater & Game Fish",
"definition": "A silvery, shallow-water fish famous for blistering runs. A premier fly-fishing target on the flats."
},
"trevally": {
"topic": "Saltwater & Game Fish",
"definition": "A strong jack-family fish found in tropical seas. Giant trevally is a famed sport fish."
},
"roosterfish": {
"topic": "Saltwater & Game Fish",
"definition": "A striking inshore fish with a tall dorsal 'comb'. Prized for its fight in the eastern Pacific."
},
"opah": {
"topic": "Saltwater & Game Fish",
"definition": "A round, colorful deep-water fish. Notable as a partially warm-blooded species."
},
"tilefish": {
"topic": "Saltwater & Game Fish",
"definition": "A colorful deep-bottom fish living in burrows. Valued for sweet, firm flesh."
},
"drum": {
"topic": "Saltwater & Game Fish",
"definition": "A fish that makes drumming sounds with its swim bladder. Includes red drum (redfish)."
},
"mullet": {
"topic": "Saltwater & Game Fish",
"definition": "A schooling coastal fish used widely as bait. Also eaten and prized for its roe."
},
"sablefish": {
"topic": "Saltwater & Game Fish",
"definition": "A deep-water fish with rich, buttery flesh. Also called black cod."
},
"rockfish": {
"topic": "Saltwater & Game Fish",
"definition": "A large group of bottom-dwelling reef fish. Many are long-lived and slow-growing."
},
"lingcod": {
"topic": "Saltwater & Game Fish",
"definition": "A toothy Pacific bottom fish. Aggressive predator and good eating."
},
"salmon": {
"topic": "Freshwater Fish",
"definition": "A migratory fish that returns to rivers to spawn. Valued for its rich flesh and epic runs."
},
"trout": {
"topic": "Freshwater Fish",
"definition": "A freshwater fish in the salmon family. Popular with fly anglers in cold streams and lakes."
},
"steelhead": {
"topic": "Freshwater Fish",
"definition": "A sea-run rainbow trout. Famed for long migrations and powerful fights."
},
"char": {
"topic": "Freshwater Fish",
"definition": "A cold-water relative of trout and salmon. Includes brook trout and Arctic char."
},
"pike": {
"topic": "Freshwater Fish",
"definition": "A long, toothy freshwater ambush predator. Strikes prey with explosive speed."
},
"muskie": {
"topic": "Freshwater Fish",
"definition": "The muskellunge, a giant pike relative. Known as 'the fish of ten thousand casts.'"
},
"walleye": {
"topic": "Freshwater Fish",
"definition": "A nocturnal predator with reflective eyes. Prized as one of the best-eating freshwater fish."
},
"perch": {
"topic": "Freshwater Fish",
"definition": "A small striped freshwater fish. A common pan fish and forage species."
},
"bass": {
"topic": "Freshwater Fish",
"definition": "A popular freshwater sport fish, including largemouth and smallmouth. Aggressive strikers."
},
"crappie": {
"topic": "Freshwater Fish",
"definition": "A small, tasty panfish that schools heavily. A favorite for casual anglers."
},
"bluegill": {
"topic": "Freshwater Fish",
"definition": "A common, colorful sunfish. Often the first fish a child catches."
},
"catfish": {
"topic": "Freshwater Fish",
"definition": "A bottom-feeding fish with whisker-like barbels. Ranges from small to enormous."
},
"carp": {
"topic": "Freshwater Fish",
"definition": "A large, hardy freshwater fish. A major sport and food fish in much of the world."
},
"grayling": {
"topic": "Freshwater Fish",
"definition": "A graceful fish with a tall, sail-like dorsal fin. Found in clean, cold rivers."
},
"sturgeon": {
"topic": "Freshwater Fish",
"definition": "An ancient, armored fish that can grow huge. Source of prized caviar."
},
"gar": {
"topic": "Freshwater Fish",
"definition": "A long, primitive fish with armor-like scales. An aggressive freshwater predator."
},
"arapaima": {
"topic": "Freshwater Fish",
"definition": "One of the largest freshwater fish, from the Amazon. Breathes air at the surface."
},
"peacock bass": {
"topic": "Freshwater Fish",
"definition": "A vivid tropical predator native to South America. A hard-hitting sport fish."
},
"tigerfish": {
"topic": "Freshwater Fish",
"definition": "A fierce African predator with dagger-like teeth. Renowned for its aggression."
},
"mahseer": {
"topic": "Freshwater Fish",
"definition": "A large carp relative from Asian rivers. A legendary sport fish."
},
"taimen": {
"topic": "Freshwater Fish",
"definition": "The world's largest trout/salmon relative, from Siberia. A rare, trophy fish."
},
"leviathan": {
"topic": "Big Ocean Creatures",
"definition": "A mythic sea monster of immense size. Symbol of something vast and powerful."
},
"kraken": {
"topic": "Big Ocean Creatures",
"definition": "A legendary giant sea creature from Norse myth. Said to drag ships under."
},
"orca": {
"topic": "Big Ocean Creatures",
"definition": "The killer whale, a powerful apex predator. Highly intelligent and social."
},
"beluga": {
"topic": "Big Ocean Creatures",
"definition": "A small white Arctic whale. Known for its bulbous head and vocal sounds."
},
"narwhal": {
"topic": "Big Ocean Creatures",
"definition": "An Arctic whale with a long spiral tusk. Often called the 'unicorn of the sea.'"
},
"manta": {
"topic": "Big Ocean Creatures",
"definition": "A huge, graceful ray with wing-like fins. Filters plankton while gliding through open water."
},
"stingray": {
"topic": "Big Ocean Creatures",
"definition": "A flat, cartilaginous fish with a venomous tail spine. Glides along sandy bottoms."
},
"hammerhead": {
"topic": "Big Ocean Creatures",
"definition": "A shark with a distinctive flattened, hammer-shaped head. Hunts rays and fish."
},
"mako": {
"topic": "Big Ocean Creatures",
"definition": "The fastest shark in the ocean. Capable of leaping high out of the water."
},
"thresher": {
"topic": "Big Ocean Creatures",
"definition": "A shark with an enormous scythe-like tail. Uses it to stun schooling prey."
},
"great white": {
"topic": "Big Ocean Creatures",
"definition": "The largest predatory shark. An iconic apex hunter of temperate seas."
},
"sawfish": {
"topic": "Big Ocean Creatures",
"definition": "A ray with a long, toothed, saw-like snout. Uses it to slash through prey."
},
"lobster": {
"topic": "Shellfish & Other Catch",
"definition": "A clawed crustacean prized as a delicacy. Caught in baited traps on the seabed."
},
"crab": {
"topic": "Shellfish & Other Catch",
"definition": "A crustacean with a hard shell and pincers. Many species are commercially fished."
},
"shrimp": {
"topic": "Shellfish & Other Catch",
"definition": "A small swimming crustacean. One of the most consumed seafoods globally."
},
"prawn": {
"topic": "Shellfish & Other Catch",
"definition": "A larger shrimp-like crustacean. Often used interchangeably with shrimp."
},
"crayfish": {
"topic": "Shellfish & Other Catch",
"definition": "A small freshwater lobster relative. A regional delicacy in many cuisines."
},
"langoustine": {
"topic": "Shellfish & Other Catch",
"definition": "A slender, small lobster relative. Prized in fine dining."
},
"oyster": {
"topic": "Shellfish & Other Catch",
"definition": "A filter-feeding mollusk eaten raw or cooked. Some produce pearls."
},
"clam": {
"topic": "Shellfish & Other Catch",
"definition": "A burrowing bivalve mollusk. Harvested from sand and mud flats."
},
"mussel": {
"topic": "Shellfish & Other Catch",
"definition": "A bivalve that clusters on rocks and ropes. Widely farmed and eaten."
},
"scallop": {
"topic": "Shellfish & Other Catch",
"definition": "A swimming bivalve with a fan-shaped shell. Valued for its sweet adductor muscle."
},
"abalone": {
"topic": "Shellfish & Other Catch",
"definition": "A large sea snail with an iridescent shell. A prized and pricey delicacy."
},
"conch": {
"topic": "Shellfish & Other Catch",
"definition": "A large marine snail with a spiral shell. Eaten and used as a horn."
},
"squid": {
"topic": "Shellfish & Other Catch",
"definition": "A fast-swimming cephalopod with ten arms. Caught widely for food and bait."
},
"octopus": {
"topic": "Shellfish & Other Catch",
"definition": "An intelligent eight-armed cephalopod. A prized catch in many cuisines."
},
"cuttlefish": {
"topic": "Shellfish & Other Catch",
"definition": "A cephalopod with an internal bone and camouflage skin. Related to squid."
},
"urchin": {
"topic": "Shellfish & Other Catch",
"definition": "A spiny seabed creature. Its roe (uni) is a delicacy."
},
"pacific": {
"topic": "Oceans & Seas",
"definition": "The largest and deepest of Earth's oceans. Spans nearly a third of the planet."
},
"atlantic": {
"topic": "Oceans & Seas",
"definition": "The second-largest ocean, dividing the Americas from Europe and Africa. A historic trade route."
},
"indian": {
"topic": "Oceans & Seas",
"definition": "The third-largest ocean, bordered by Africa, Asia, and Australia. Warm and monsoon-driven."
},
"arctic": {
"topic": "Oceans & Seas",
"definition": "The smallest, shallowest, and coldest ocean. Largely covered by sea ice."
},
"southern": {
"topic": "Oceans & Seas",
"definition": "The ocean encircling Antarctica. Home to powerful circumpolar currents."
},
"coral sea": {
"topic": "Oceans & Seas",
"definition": "A warm sea off northeastern Australia. Home to the Great Barrier Reef."
},
"caspian": {
"topic": "Oceans & Seas",
"definition": "The world's largest inland body of water. Technically a lake but called a sea."
},
"adriatic": {
"topic": "Oceans & Seas",
"definition": "An arm of the Mediterranean between Italy and the Balkans. Known for clear blue water."
},
"aegean": {
"topic": "Oceans & Seas",
"definition": "A Mediterranean sea dotted with Greek islands. Steeped in ancient history."
},
"baltic": {
"topic": "Oceans & Seas",
"definition": "A brackish northern European sea. Surrounded by Scandinavia and the Baltic states."
},
"bering": {
"topic": "Oceans & Seas",
"definition": "A cold, rich sea between Russia and Alaska. Famous for crab and pollock fisheries."
},
"sargasso": {
"topic": "Oceans & Seas",
"definition": "A calm Atlantic region defined by floating seaweed. Unique for having no land borders."
},
"tasman": {
"topic": "Oceans & Seas",
"definition": "The sea between Australia and New Zealand. Known for rough crossings."
},
"andaman": {
"topic": "Oceans & Seas",
"definition": "A tropical sea east of the Bay of Bengal. Known for islands and reefs."
},
"caribbean": {
"topic": "Oceans & Seas",
"definition": "A warm tropical sea among island nations. Famed for clear water and reefs."
},
"mediterranean": {
"topic": "Oceans & Seas",
"definition": "A sea enclosed by Europe, Africa, and Asia. Cradle of many ancient civilizations."
},
"red sea": {
"topic": "Oceans & Seas",
"definition": "A narrow sea between Africa and Arabia. Known for warm water and vibrant reefs."
},
"north sea": {
"topic": "Oceans & Seas",
"definition": "A shallow sea off northwestern Europe. A major fishing and oil region."
},
"barents": {
"topic": "Oceans & Seas",
"definition": "An Arctic sea north of Norway and Russia. A productive cold-water fishery."
},
"gulf stream": {
"topic": "Currents",
"definition": "A warm, swift Atlantic current flowing from the Gulf of Mexico. It moderates Europe's climate."
},
"kuroshio": {
"topic": "Currents",
"definition": "A strong warm current off Japan, the Pacific's Gulf Stream. Its name means 'black tide.'"
},
"humboldt": {
"topic": "Currents",
"definition": "A cold, nutrient-rich current off South America's west coast. Supports vast fisheries."
},
"agulhas": {
"topic": "Currents",
"definition": "A powerful warm current along southeastern Africa. One of the strongest western boundary currents."
},
"canary": {
"topic": "Currents",
"definition": "A cool current flowing past northwest Africa. Drives rich coastal upwelling."
},
"benguela": {
"topic": "Currents",
"definition": "A cold upwelling current off southwestern Africa. Feeds enormous fish populations."
},
"oyashio": {
"topic": "Currents",
"definition": "A cold current flowing south past eastern Russia and Japan. Brings nutrient-rich Arctic water."
},
"labrador": {
"topic": "Currents",
"definition": "A cold current carrying Arctic water south along Canada. Brings icebergs into shipping lanes."
},
"leeuwin": {
"topic": "Currents",
"definition": "A warm current flowing down Western Australia's coast. Unusual for a west-coast current."
},
"equatorial": {
"topic": "Currents",
"definition": "A wind-driven current flowing along the equator. Helps redistribute ocean heat."
},
"riptide": {
"topic": "Currents",
"definition": "A strong, narrow flow of water rushing back to sea. A hazard to swimmers."
},
"undertow": {
"topic": "Currents",
"definition": "A subsurface current pulling water back beneath breaking waves. Can sweep swimmers off their feet."
},
"eddy": {
"topic": "Currents",
"definition": "A circular swirl of water spinning off a main current. Can trap and concentrate fish."
},
"gyre": {
"topic": "Currents",
"definition": "A large, rotating system of ocean currents. Driven by winds and Earth's rotation."
},
"upwelling": {
"topic": "Currents",
"definition": "The rise of cold, nutrient-rich water to the surface. Fuels productive fishing grounds."
},
"tide": {
"topic": "Currents",
"definition": "The regular rise and fall of the sea. Driven by the moon's and sun's gravity."
},
"ebb": {
"topic": "Currents",
"definition": "The outgoing tide as water flows back to sea. The falling phase of the tidal cycle."
},
"surge": {
"topic": "Currents",
"definition": "A sudden, strong rush or swell of water. Often driven by storms."
},
"swell": {
"topic": "Currents",
"definition": "Long, rolling waves traveling across open water. Generated by distant winds."
},
"hook": {
"topic": "Gear & Tackle",
"definition": "The sharp, curved point that catches fish. The fundamental tool of angling."
},
"line": {
"topic": "Gear & Tackle",
"definition": "The cord connecting angler to hook. Comes in mono, braid, and fluorocarbon."
},
"sinker": {
"topic": "Gear & Tackle",
"definition": "A weight that takes bait or lure down. Keeps the line near the bottom."
},
"lure": {
"topic": "Gear & Tackle",
"definition": "An artificial bait that mimics prey. Designed to trigger a strike."
},
"bait": {
"topic": "Gear & Tackle",
"definition": "Natural food used to attract fish. Can be live or cut."
},
"reel": {
"topic": "Gear & Tackle",
"definition": "The mechanism that stores and retrieves line. The heart of a fishing rig."
},
"rod": {
"topic": "Gear & Tackle",
"definition": "The flexible pole used to cast and fight fish. Comes in many lengths and actions."
},
"trawl": {
"topic": "Gear & Tackle",
"definition": "A large net dragged through the water to catch fish. A major commercial method."
},
"net": {
"topic": "Gear & Tackle",
"definition": "A mesh tool for catching or landing fish. Ranges from hand nets to vast seines."
},
"seine": {
"topic": "Gear & Tackle",
"definition": "A long net that hangs vertically to encircle fish. Drawn closed to trap the catch."
},
"harpoon": {
"topic": "Gear & Tackle",
"definition": "A barbed spear thrown or fired at large fish. Historically used for whales and tuna."
},
"jig": {
"topic": "Gear & Tackle",
"definition": "A weighted hook worked with an up-and-down motion. A versatile, productive lure."
},
"fly": {
"topic": "Gear & Tackle",
"definition": "A tiny lure imitating an insect or baitfish. Cast using a weighted fly line."
},
"spinner": {
"topic": "Gear & Tackle",
"definition": "A lure with a rotating blade that flashes and vibrates. Attracts predatory fish."
},
"spoon": {
"topic": "Gear & Tackle",
"definition": "A curved metal lure that wobbles like a fleeing fish. A classic, simple design."
},
"popper": {
"topic": "Gear & Tackle",
"definition": "A surface lure that splashes and 'pops' on retrieve. Triggers explosive topwater strikes."
},
"bobber": {
"topic": "Gear & Tackle",
"definition": "A float that suspends bait and signals bites. Also called a cork or float."
},
"chum": {
"topic": "Gear & Tackle",
"definition": "Ground bait scattered to draw fish in. Builds a feeding frenzy near the boat."
},
"gaff": {
"topic": "Gear & Tackle",
"definition": "A large hook on a pole for landing big fish. Used to haul a catch aboard."
},
"spear": {
"topic": "Gear & Tackle",
"definition": "A pointed shaft used to strike fish directly. The tool of spearfishing."
},
"leader": {
"topic": "Gear & Tackle",
"definition": "A length of stronger line near the hook. Resists abrasion and sharp teeth."
},
"swivel": {
"topic": "Gear & Tackle",
"definition": "A small rotating connector preventing line twist. Joins line to leader."
},
"creel": {
"topic": "Gear & Tackle",
"definition": "A wicker basket for holding caught fish. A traditional angler's accessory."
},
"weir": {
"topic": "Gear & Tackle",
"definition": "A fence or barrier that funnels fish into a trap. An ancient fishing structure."
},
"trap": {
"topic": "Gear & Tackle",
"definition": "An enclosure that lets fish in but not out. Used for crab, lobster, and eel."
},
"dredge": {
"topic": "Gear & Tackle",
"definition": "A heavy frame dragged to harvest shellfish. Scrapes the seabed for scallops and clams."
},
"outrigger": {
"topic": "Gear & Tackle",
"definition": "A pole that spreads trolling lines wide of the boat. Prevents tangles while trolling."
},
"downrigger": {
"topic": "Gear & Tackle",
"definition": "A device that sinks trolling lures to precise depths. Used for deep trolling."
},
"clinch": {
"topic": "Knots & Rigging",
"definition": "A simple, reliable knot for tying line to a hook. One of the first knots anglers learn."
},
"palomar": {
"topic": "Knots & Rigging",
"definition": "A strong, easy knot trusted for braided line. Tied with a doubled loop."
},
"albright": {
"topic": "Knots & Rigging",
"definition": "A knot joining two lines of different sizes. Common for attaching leaders."
},
"blood knot": {
"topic": "Knots & Rigging",
"definition": "A knot joining two similar lines smoothly. Favored in fly fishing."
},
"uni": {
"topic": "Knots & Rigging",
"definition": "A versatile, dependable all-purpose fishing knot. Also called the Duncan loop."
},
"bimini": {
"topic": "Knots & Rigging",
"definition": "A knot creating a strong double-line loop. Used in offshore big-game rigs."
},
"snell": {
"topic": "Knots & Rigging",
"definition": "A method of tying line directly to a hook shank. Improves hook-setting power."
},
"dropper": {
"topic": "Knots & Rigging",
"definition": "A short branch line carrying an extra hook or fly. Lets you fish two baits at once."
},
"rig": {
"topic": "Knots & Rigging",
"definition": "An arrangement of hooks, weights, and line. Built for a specific fishing situation."
},
"ledger": {
"topic": "Knots & Rigging",
"definition": "A bottom rig with the weight fixed below the bait. Used for still-water bottom fishing."
},
"reef": {
"topic": "Water & Coastal Features",
"definition": "A ridge of rock or coral near the surface. A magnet for marine life and anglers."
},
"shoal": {
"topic": "Water & Coastal Features",
"definition": "A shallow sandbank or a dense group of fish. Both meanings matter on the water."
},
"bank": {
"topic": "Water & Coastal Features",
"definition": "An underwater rise or plateau. Often a rich fishing ground."
},
"flat": {
"topic": "Water & Coastal Features",
"definition": "A broad, shallow expanse of water. Prime habitat for bonefish and permit."
},
"channel": {
"topic": "Water & Coastal Features",
"definition": "A deeper path of water through shallows. Fish use it as a highway."
},
"trench": {
"topic": "Water & Coastal Features",
"definition": "A deep, narrow depression in the seafloor. The ocean's deepest features."
},
"abyss": {
"topic": "Water & Coastal Features",
"definition": "The deep, dark zone of the open ocean. Cold and largely unexplored."
},
"shelf": {
"topic": "Water & Coastal Features",
"definition": "The gently sloping seabed near a coast. Where most marine life concentrates."
},
"estuary": {
"topic": "Water & Coastal Features",
"definition": "Where a river meets the sea and waters mix. A rich nursery for many fish."
},
"lagoon": {
"topic": "Water & Coastal Features",
"definition": "A sheltered shallow body of water behind a reef or barrier. Calm and often clear."
},
"cove": {
"topic": "Water & Coastal Features",
"definition": "A small, sheltered coastal inlet. A calm spot to anchor or fish."
},
"inlet": {
"topic": "Water & Coastal Features",
"definition": "A narrow opening where the sea reaches inland. Often a busy fishing passage."
},
"sound": {
"topic": "Water & Coastal Features",
"definition": "A wide ocean inlet or channel between land. Often a productive fishing area."
},
"strait": {
"topic": "Water & Coastal Features",
"definition": "A narrow channel connecting two larger waters. A natural funnel for currents."
},
"fjord": {
"topic": "Water & Coastal Features",
"definition": "A deep, steep-sided inlet carved by glaciers. Common along Norway's coast."
},
"atoll": {
"topic": "Water & Coastal Features",
"definition": "A ring-shaped coral reef surrounding a lagoon. Found in tropical seas."
},
"shallows": {
"topic": "Water & Coastal Features",
"definition": "Areas of low water depth near shore. Warm zones where fish feed."
},
"kelp": {
"topic": "Water & Coastal Features",
"definition": "Large brown seaweed forming underwater forests. Shelters abundant marine life."
},
"wreck": {
"topic": "Water & Coastal Features",
"definition": "A sunken ship that becomes an artificial reef. A hotspot for fish and divers."
},
"surf": {
"topic": "Water & Coastal Features",
"definition": "The zone of breaking waves near shore. Where surfcasters target fish."
},
"breaker": {
"topic": "Water & Coastal Features",
"definition": "A wave that collapses into white foam as it nears shore. A marker of shallow water."
},
"trawler": {
"topic": "Boats & Vessels",
"definition": "A boat that drags nets to catch fish. A workhorse of commercial fishing."
},
"dory": {
"topic": "Boats & Vessels",
"definition": "A small, flat-bottomed rowing boat. Traditionally used for hand-line fishing."
},
"skiff": {
"topic": "Boats & Vessels",
"definition": "A light, shallow-draft boat. Ideal for poling the flats."
},
"sloop": {
"topic": "Boats & Vessels",
"definition": "A single-masted sailing boat. Simple and seaworthy."
},
"schooner": {
"topic": "Boats & Vessels",
"definition": "A sailing ship with two or more masts. Historically used in fishing fleets."
},
"cutter": {
"topic": "Boats & Vessels",
"definition": "A fast, single-masted sailing vessel. Also a type of patrol boat."
},
"longliner": {
"topic": "Boats & Vessels",
"definition": "A vessel that fishes with long baited lines. Targets tuna and swordfish."
},
"drifter": {
"topic": "Boats & Vessels",
"definition": "A boat that fishes with drifting nets. Moves with the current."
},
"kayak": {
"topic": "Boats & Vessels",
"definition": "A small paddle craft increasingly used for fishing. Quiet and able to reach skinny water."
},
"canoe": {
"topic": "Boats & Vessels",
"definition": "A narrow paddle boat. Useful on rivers and calm lakes."
},
"woolly bugger": {
"topic": "Fly Patterns",
"definition": "A versatile, fuzzy streamer fly. Catches almost everything that swims."
},
"adams": {
"topic": "Fly Patterns",
"definition": "A classic gray dry fly imitating many mayflies. A staple of every fly box."
},
"royal wulff": {
"topic": "Fly Patterns",
"definition": "A bushy, high-floating dry fly with a red band. Easy to see on rough water."
},
"elk hair caddis": {
"topic": "Fly Patterns",
"definition": "A buoyant dry fly imitating a caddisfly. Tied with elk hair wings."
},
"pheasant tail": {
"topic": "Fly Patterns",
"definition": "A slim nymph tied from pheasant feathers. Imitates mayfly larvae."
},
"hare's ear": {
"topic": "Fly Patterns",
"definition": "A scruffy, buggy nymph pattern. Suggests many underwater insects."
},
"prince nymph": {
"topic": "Fly Patterns",
"definition": "A flashy nymph with white wings. A reliable searching pattern."
},
"copper john": {
"topic": "Fly Patterns",
"definition": "A weighted nymph with a copper-wire body. Sinks fast to reach feeding fish."
},
"clouser": {
"topic": "Fly Patterns",
"definition": "A weighted baitfish streamer. A go-to for both fresh and saltwater."
},
"muddler": {
"topic": "Fly Patterns",
"definition": "A deer-hair fly imitating a sculpin or grasshopper. Versatile and durable."
},
"stimulator": {
"topic": "Fly Patterns",
"definition": "A large, buoyant dry fly imitating stoneflies and hoppers. Floats high in fast water."
},
"hopper": {
"topic": "Fly Patterns",
"definition": "A dry fly imitating a grasshopper. Deadly in late summer."
},
"mayfly": {
"topic": "Fly Patterns",
"definition": "A delicate aquatic insect and its imitations. A cornerstone of fly fishing."
},
"caddis": {
"topic": "Fly Patterns",
"definition": "An aquatic insect and the flies that mimic it. A major trout food."
},
"midge": {
"topic": "Fly Patterns",
"definition": "A tiny aquatic insect and its imitations. Crucial in cold, clear water."
},
"streamer": {
"topic": "Fly Patterns",
"definition": "A larger fly imitating baitfish or leeches. Stripped to provoke aggressive strikes."
},
"nymph": {
"topic": "Fly Patterns",
"definition": "A subsurface fly imitating immature insects. Fished below the surface."
},
"emerger": {
"topic": "Fly Patterns",
"definition": "A fly imitating an insect rising to hatch. Fished in the surface film."
},
"hackle": {
"topic": "Fly Patterns",
"definition": "The feather wound around a fly for flotation and movement. A core fly-tying material."
},
"osprey": {
"topic": "Seabirds & Predators",
"definition": "A fish-hunting raptor that dives talons-first. Also called the fish hawk."
},
"pelican": {
"topic": "Seabirds & Predators",
"definition": "A large seabird with a huge throat pouch. Scoops fish from the water."
},
"cormorant": {
"topic": "Seabirds & Predators",
"definition": "A diving seabird that pursues fish underwater. Once trained to fish for people."
},
"gannet": {
"topic": "Seabirds & Predators",
"definition": "A seabird that plunge-dives from great height. Hits the water like an arrow."
},
"kingfisher": {
"topic": "Seabirds & Predators",
"definition": "A small, brilliant bird that dives for fish. Famous for its precision."
},
"heron": {
"topic": "Seabirds & Predators",
"definition": "A tall wading bird that spears fish. A patient, motionless hunter."
},
"egret": {
"topic": "Seabirds & Predators",
"definition": "A slender white wading bird. Stalks fish in the shallows."
},
"tern": {
"topic": "Seabirds & Predators",
"definition": "A graceful seabird that dives for small fish. A nimble, agile flier."
},
"albatross": {
"topic": "Seabirds & Predators",
"definition": "A vast ocean-wandering seabird. Glides for hours without flapping."
},
"puffin": {
"topic": "Seabirds & Predators",
"definition": "A small, colorful seabird that dives for fish. Carries several in its beak at once."
},
"otter": {
"topic": "Seabirds & Predators",
"definition": "A playful aquatic mammal that hunts fish. Found in rivers and along coasts."
},
"loon": {
"topic": "Seabirds & Predators",
"definition": "A diving water bird known for haunting calls. A skilled underwater fish hunter."
},
"poseidon": {
"topic": "Myth & Folklore",
"definition": "The Greek god of the sea. Wields a trident and stirs storms."
},
"neptune": {
"topic": "Myth & Folklore",
"definition": "The Roman god of the sea. Counterpart to Poseidon."
},
"triton": {
"topic": "Myth & Folklore",
"definition": "A Greek sea god and messenger of the deep. Blows a conch-shell horn."
},
"nereid": {
"topic": "Myth & Folklore",
"definition": "A sea nymph of Greek myth. Daughters of the sea god Nereus."
},
"siren": {
"topic": "Myth & Folklore",
"definition": "A mythical creature whose song lured sailors to wreck. A symbol of dangerous allure."
},
"mermaid": {
"topic": "Myth & Folklore",
"definition": "A legendary half-human, half-fish sea being. A staple of maritime folklore."
},
"selkie": {
"topic": "Myth & Folklore",
"definition": "A mythical seal that can become human on land. From Scottish and Irish legend."
},
"charybdis": {
"topic": "Myth & Folklore",
"definition": "A mythical sea monster that formed a deadly whirlpool. A peril for ancient sailors."
},
"scylla": {
"topic": "Myth & Folklore",
"definition": "A many-headed sea monster of Greek myth. Paired with Charybdis as twin dangers."
},
"aegir": {
"topic": "Myth & Folklore",
"definition": "The Norse personification of the sea. A giant who brews for the gods."
},
"njord": {
"topic": "Myth & Folklore",
"definition": "The Norse god of the sea, wind, and fishing. Patron of sailors and prosperity."
},
"mazu": {
"topic": "Myth & Folklore",
"definition": "The Chinese goddess of the sea. Protector of sailors and fishermen."
},
"sedna": {
"topic": "Myth & Folklore",
"definition": "The Inuit goddess of the sea and marine animals. Ruler of the ocean depths."
},
"tangaroa": {
"topic": "Myth & Folklore",
"definition": "The Polynesian god of the sea. Ancestor of fish and sea creatures."
},
"davy jones": {
"topic": "Myth & Folklore",
"definition": "Sailors' nickname for the spirit of the sea. 'Davy Jones's locker' means the ocean floor."
},
"nautilus": {
"topic": "Myth & Folklore",
"definition": "A spiral-shelled sea creature, also a famous fictional submarine. Symbol of the deep."
},
"argonaut": {
"topic": "Myth & Folklore",
"definition": "A hero who sailed with Jason, also a type of octopus. Evokes seafaring quests."
},
"bow": {
"topic": "Nautical Terms",
"definition": "The front of a boat. Cuts through the water first."
},
"stern": {
"topic": "Nautical Terms",
"definition": "The rear of a boat. Opposite the bow."
},
"hull": {
"topic": "Nautical Terms",
"definition": "The main body of a vessel. Keeps it afloat."
},
"keel": {
"topic": "Nautical Terms",
"definition": "The backbone running along a boat's bottom. Provides stability."
},
"mast": {
"topic": "Nautical Terms",
"definition": "The tall vertical pole carrying sails. The spine of a sailing rig."
},
"helm": {
"topic": "Nautical Terms",
"definition": "The wheel or tiller used to steer. The command position of a boat."
},
"rudder": {
"topic": "Nautical Terms",
"definition": "The flat blade at the stern that steers the boat. Turned by the helm."
},
"bridge": {
"topic": "Nautical Terms",
"definition": "The control room of a large vessel. Where the captain commands."
},
"galley": {
"topic": "Nautical Terms",
"definition": "A boat's kitchen. Where meals are prepared at sea."
},
"deck": {
"topic": "Nautical Terms",
"definition": "The flat surface you stand on aboard a boat. The working floor of a vessel."
},
"starboard": {
"topic": "Nautical Terms",
"definition": "The right side of a vessel when facing forward. Opposite of port."
},
"port": {
"topic": "Nautical Terms",
"definition": "The left side of a vessel when facing forward. Opposite of starboard."
},
"anchor": {
"topic": "Nautical Terms",
"definition": "A heavy device that holds a boat in place. Grips the seabed."
},
"buoy": {
"topic": "Nautical Terms",
"definition": "A floating marker on the water. Guides navigation or marks gear."
},
"compass": {
"topic": "Nautical Terms",
"definition": "An instrument showing direction. Essential for navigation at sea."
},
"sextant": {
"topic": "Nautical Terms",
"definition": "A tool for measuring angles to navigate by the stars. A classic seafaring instrument."
},
"tiller": {
"topic": "Nautical Terms",
"definition": "A lever used to turn the rudder. Steers smaller boats."
},
"boom": {
"topic": "Nautical Terms",
"definition": "The horizontal spar holding the bottom of a sail. Swings across the deck when turning."
},
"jib": {
"topic": "Nautical Terms",
"definition": "A triangular sail set ahead of the mast. Helps drive the boat forward."
},
"squall": {
"topic": "Weather at Sea",
"definition": "A sudden, violent burst of wind and rain. A quick maritime hazard."
},
"gale": {
"topic": "Weather at Sea",
"definition": "A very strong, sustained wind. Forces caution at sea."
},
"doldrums": {
"topic": "Weather at Sea",
"definition": "A windless equatorial belt that stalls sailing ships. Also means a state of stagnation."
},
"tempest": {
"topic": "Weather at Sea",
"definition": "A violent, windy storm. A dramatic word for foul weather."
},
"monsoon": {
"topic": "Weather at Sea",
"definition": "A seasonal wind bringing heavy rains. Drives weather across the Indian Ocean."
},
"trade wind": {
"topic": "Weather at Sea",
"definition": "Steady winds blowing toward the equator. Long used to power sailing voyages."
},
"nor'easter": {
"topic": "Weather at Sea",
"definition": "A powerful coastal storm with northeast winds. Batters the U.S. East Coast."
},
"mistral": {
"topic": "Weather at Sea",
"definition": "A cold, strong wind blowing down toward the Mediterranean. Famous in southern France."
},
"sirocco": {
"topic": "Weather at Sea",
"definition": "A hot, dusty wind from the Sahara. Sweeps across the Mediterranean."
},
"spindrift": {
"topic": "Weather at Sea",
"definition": "Spray blown from wave crests by strong wind. A sign of rough seas."
},
"gust": {
"topic": "Weather at Sea",
"definition": "A brief, sudden increase in wind speed. Can catch sailors off guard."
},
"storm": {
"topic": "Weather at Sea",
"definition": "A violent disturbance of wind and rain. The classic test of any sailor."
},
"cyclone": {
"topic": "Weather at Sea",
"definition": "A large rotating storm system. The general term for hurricanes and typhoons."
},
"typhoon": {
"topic": "Weather at Sea",
"definition": "A powerful tropical cyclone in the western Pacific. The same as a hurricane elsewhere."
},
"maelstrom": {
"topic": "Weather at Sea",
"definition": "A powerful whirlpool or chaotic swirl of water. A symbol of overwhelming force."
},
"spring tide": {
"topic": "Tides & Timing",
"definition": "An extra-large tide at new and full moons. Strong currents and big swings."
},
"neap tide": {
"topic": "Tides & Timing",
"definition": "A small tide with little range. Occurs at quarter moons."
},
"high tide": {
"topic": "Tides & Timing",
"definition": "The peak of the tidal cycle. When water reaches its highest point."
},
"slack": {
"topic": "Tides & Timing",
"definition": "The brief still period between tides. When the current pauses."
},
"flood": {
"topic": "Tides & Timing",
"definition": "The incoming tide as water rises. The rising phase of the cycle."
},
"solunar": {
"topic": "Tides & Timing",
"definition": "Relating to sun-and-moon timing of fish activity. The basis of bite-prediction tables."
},
"full moon": {
"topic": "Tides & Timing",
"definition": "The fully lit phase of the moon. Linked to strong tides and night feeding."
},
"new moon": {
"topic": "Tides & Timing",
"definition": "The dark phase of the moon. Also a time of strong spring tides."
},
"equinox": {
"topic": "Tides & Timing",
"definition": "When day and night are equal in length. Associated with strong seasonal tides."
},
"tidal bore": {
"topic": "Tides & Timing",
"definition": "A wave that surges up a river against the current. Caused by an incoming tide."
},
"yellowstone": {
"topic": "Famous Fishing Waters",
"definition": "A storied river and park region. Legendary for wild trout."
},
"madison": {
"topic": "Famous Fishing Waters",
"definition": "A famed Montana trout river. A blue-ribbon fly-fishing destination."
},
"henry's fork": {
"topic": "Famous Fishing Waters",
"definition": "A celebrated Idaho trout stream. Known for challenging, technical fishing."
},
"bighorn": {
"topic": "Famous Fishing Waters",
"definition": "A renowned tailwater trout river. Produces large, well-fed trout."
},
"deschutes": {
"topic": "Famous Fishing Waters",
"definition": "A wild Oregon river. Famous for redside trout and steelhead."
},
"kenai": {
"topic": "Famous Fishing Waters",
"definition": "An Alaskan river known for giant salmon. Home to record king salmon."
},
"tay": {
"topic": "Famous Fishing Waters",
"definition": "Scotland's longest river. A historic Atlantic salmon water."
},
"spey": {
"topic": "Famous Fishing Waters",
"definition": "A Scottish salmon river that gave its name to a casting style. Iconic in fly fishing."
},
"tweed": {
"topic": "Famous Fishing Waters",
"definition": "A famed salmon river on the Scotland–England border. A storied fly-fishing destination."
},
"test": {
"topic": "Famous Fishing Waters",
"definition": "A classic English chalk stream. The birthplace of modern dry-fly fishing."
},
"miramichi": {
"topic": "Famous Fishing Waters",
"definition": "A Canadian river famous for Atlantic salmon. A bucket-list destination."
},
"montauk": {
"topic": "Famous Fishing Waters",
"definition": "A legendary fishing point at Long Island's tip. Known for striped bass blitzes."
},
"gloucester": {
"topic": "Famous Fishing Waters",
"definition": "A historic Massachusetts fishing port. Immortalized in seafaring lore."
},
"bristol bay": {
"topic": "Famous Fishing Waters",
"definition": "An Alaskan bay with the world's largest sockeye salmon run. A fishing powerhouse."
},
"crankbait": {
"topic": "Lures & Rigs",
"definition": "A diving lure that wobbles on retrieve. Imitates a fleeing baitfish."
},
"jerkbait": {
"topic": "Lures & Rigs",
"definition": "A lure twitched to dart erratically. Mimics a wounded fish."
},
"swimbait": {
"topic": "Lures & Rigs",
"definition": "A soft or jointed lure with a lifelike swimming action. Targets big predators."
},
"buzzbait": {
"topic": "Lures & Rigs",
"definition": "A surface lure with a churning blade. Creates noise and a tempting wake."
},
"spinnerbait": {
"topic": "Lures & Rigs",
"definition": "A lure with flashing blades and a skirted hook. A bass-fishing staple."
},
"topwater": {
"topic": "Lures & Rigs",
"definition": "Any lure worked on the surface. Produces thrilling visual strikes."
},
"dropshot": {
"topic": "Lures & Rigs",
"definition": "A finesse rig with the weight below the hook. Suspends bait off the bottom."
},
"texas rig": {
"topic": "Lures & Rigs",
"definition": "A weedless soft-plastic rig with the hook buried in the bait. Great around cover."
},
"carolina rig": {
"topic": "Lures & Rigs",
"definition": "A bottom rig with a sliding weight ahead of a leader. Covers water efficiently."
},
"chatterbait": {
"topic": "Lures & Rigs",
"definition": "A bladed jig that vibrates strongly. Combines flash and thump."
},
"bucktail": {
"topic": "Lures & Rigs",
"definition": "A jig dressed with deer-hair fibers. A timeless, versatile lure."
},
"nightcrawler": {
"topic": "Live & Natural Bait",
"definition": "A large earthworm used as bait. A universal favorite for many fish."
},
"minnow": {
"topic": "Live & Natural Bait",
"definition": "A small baitfish used live or dead. Catches a wide range of predators."
},
"shiner": {
"topic": "Live & Natural Bait",
"definition": "A bright, silvery baitfish. A top live bait for bass and pike."
},
"leech": {
"topic": "Live & Natural Bait",
"definition": "A worm-like bait that wriggles enticingly. Effective for walleye and panfish."
},
"sandworm": {
"topic": "Live & Natural Bait",
"definition": "A marine worm dug from tidal flats. A prime saltwater bait."
},
"bloodworm": {
"topic": "Live & Natural Bait",
"definition": "A red marine worm used as bait. Prized for saltwater species."
},
"ballyhoo": {
"topic": "Live & Natural Bait",
"definition": "A slender baitfish rigged for offshore trolling. A staple for billfish and tuna."
},
"menhaden": {
"topic": "Live & Natural Bait",
"definition": "An oily baitfish, also called bunker. Vital forage and a top cut bait."
},
"pilchard": {
"topic": "Live & Natural Bait",
"definition": "A small oily baitfish. Used live to chum and hook predators."
},
"trolling": {
"topic": "Types of Fishing",
"definition": "Dragging lures or bait behind a moving boat. Covers water to find fish."
},
"jigging": {
"topic": "Types of Fishing",
"definition": "Working a weighted lure up and down. An active, hands-on technique."
},
"spearfishing": {
"topic": "Types of Fishing",
"definition": "Hunting fish underwater with a spear. Combines diving and fishing."
},
"ice fishing": {
"topic": "Types of Fishing",
"definition": "Fishing through a hole cut in frozen water. A winter tradition."
},
"surfcasting": {
"topic": "Types of Fishing",
"definition": "Casting from a beach into the surf. Targets fish in the breakers."
},
"bottom fishing": {
"topic": "Types of Fishing",
"definition": "Fishing with bait resting on the seabed. Targets groundfish and structure dwellers."
},
"deep sea": {
"topic": "Types of Fishing",
"definition": "Fishing in deep offshore waters. Pursues large pelagic species."
},
"longlining": {
"topic": "Types of Fishing",
"definition": "Commercial fishing with long, baited lines. Sets thousands of hooks."
},
"noodling": {
"topic": "Types of Fishing",
"definition": "Catching catfish by hand in their holes. A daring Southern tradition."
},
"angling": {
"topic": "Types of Fishing",
"definition": "The sport of catching fish with a rod and line. The general term for recreational fishing."
},
"chumming": {
"topic": "Types of Fishing",
"definition": "Scattering bait to attract fish. Builds a feeding frenzy."
},
"drift fishing": {
"topic": "Types of Fishing",
"definition": "Letting the boat drift while presenting bait. Covers water with the current."
},
"lighthouse": {
"topic": "Navigation & Deep Sea",
"definition": "A coastal tower with a guiding light. Warns ships of hazards."
},
"beacon": {
"topic": "Navigation & Deep Sea",
"definition": "A signal light or marker for navigation. Guides vessels safely."
},
"mariner": {
"topic": "Navigation & Deep Sea",
"definition": "A sailor or seafarer. One who works the sea."
},
"compass rose": {
"topic": "Navigation & Deep Sea",
"definition": "The figure on a chart showing directions. Marks the points of the compass."
},
"fathom": {
"topic": "Navigation & Deep Sea",
"definition": "A unit of water depth equal to six feet. Used to measure soundings."
},
"latitude": {
"topic": "Navigation & Deep Sea",
"definition": "The north–south position on the globe. Measured in degrees from the equator."
},
"longitude": {
"topic": "Navigation & Deep Sea",
"definition": "The east–west position on the globe. Measured from the prime meridian."
},
"meridian": {
"topic": "Navigation & Deep Sea",
"definition": "A line of longitude running pole to pole. Used to fix east-west position."
},
"mariana": {
"topic": "Navigation & Deep Sea",
"definition": "The deepest ocean trench on Earth. Plunges nearly 11 kilometers down."
},
"seamount": {
"topic": "Navigation & Deep Sea",
"definition": "An underwater mountain rising from the seabed. A hotspot for marine life."
},
"pelagic": {
"topic": "Navigation & Deep Sea",
"definition": "Relating to the open water column. Describes fish like tuna and marlin."
},
"benthic": {
"topic": "Navigation & Deep Sea",
"definition": "Relating to the seabed. Describes bottom-dwelling life."
},
"thermocline": {
"topic": "Navigation & Deep Sea",
"definition": "A layer where water temperature changes sharply. Fish often hold along it."
},
"pisces": {
"topic": "Sea Constellations",
"definition": "The zodiac constellation of the fish. A natural fit for a fishing theme."
},
"cetus": {
"topic": "Sea Constellations",
"definition": "The constellation of the whale or sea monster. A giant of the night sky."
},
"delphinus": {
"topic": "Sea Constellations",
"definition": "The constellation of the dolphin. A small but charming star group."
},
"eridanus": {
"topic": "Sea Constellations",
"definition": "The constellation depicting a celestial river. Winds across the southern sky."
},
"aquarius": {
"topic": "Sea Constellations",
"definition": "The zodiac constellation of the water-bearer. Linked to water and the sea."
},
"polaris": {
"topic": "Sea Constellations",
"definition": "The North Star, used for navigation. A fixed guide for mariners."
},
"sirius": {
"topic": "Sea Constellations",
"definition": "The brightest star in the night sky. A key navigational marker."
},
"southern cross": {
"topic": "Sea Constellations",
"definition": "A famous southern-sky constellation. Long used to find south at sea."
},
"humpback": {
"topic": "Whales",
"definition": "A large baleen whale famous for breaching and song. A favorite of whale watchers."
},
"sperm whale": {
"topic": "Whales",
"definition": "The largest toothed whale, a deep diver. Hunts giant squid in the abyss."
},
"blue whale": {
"topic": "Whales",
"definition": "The largest animal that has ever lived. A true ocean giant."
},
"right whale": {
"topic": "Whales",
"definition": "A slow, heavy baleen whale. Once heavily hunted, now rare."
},
"fin whale": {
"topic": "Whales",
"definition": "The second-largest whale, sleek and fast. Nicknamed the 'greyhound of the sea.'"
},
"minke": {
"topic": "Whales",
"definition": "One of the smallest baleen whales. Quick and widely distributed."
},
"gray whale": {
"topic": "Whales",
"definition": "A baleen whale famed for long coastal migrations. Travels thousands of miles yearly."
},
"bowhead": {
"topic": "Whales",
"definition": "An Arctic whale with a massive head for breaking ice. Among the longest-lived mammals."
},
"pilot whale": {
"topic": "Whales",
"definition": "A large, social dolphin-family whale. Travels in tight pods."
},
"chinook": {
"topic": "Salmon & Tuna Grades",
"definition": "The largest Pacific salmon, also called king. Prized for size and rich flesh."
},
"coho": {
"topic": "Salmon & Tuna Grades",
"definition": "A Pacific salmon, also called silver. A spirited sport fish."
},
"sockeye": {
"topic": "Salmon & Tuna Grades",
"definition": "A deep-red Pacific salmon. Highly valued for its color and flavor."
},
"pink": {
"topic": "Salmon & Tuna Grades",
"definition": "The smallest, most abundant Pacific salmon. Returns in huge numbers."
},
"kokanee": {
"topic": "Salmon & Tuna Grades",
"definition": "A landlocked sockeye salmon. Lives entirely in freshwater."
},
"bigeye": {
"topic": "Salmon & Tuna Grades",
"definition": "A deep-dwelling tuna prized for sashimi. Has notably large eyes."
},
"albacore": {
"topic": "Salmon & Tuna Grades",
"definition": "A tuna with pale flesh, the 'white' canned tuna. Roams temperate seas."
},
"blackfin": {
"topic": "Salmon & Tuna Grades",
"definition": "The smallest tuna species. A spirited light-tackle target."
},
"dogtooth": {
"topic": "Salmon & Tuna Grades",
"definition": "A powerful reef tuna with dagger-like teeth. A prized tropical sport fish."
},
"barnacle": {
"topic": "Reef & Marine Life",
"definition": "A small crustacean that cements itself to surfaces. Encrusts hulls and rocks."
},
"krill": {
"topic": "Reef & Marine Life",
"definition": "Tiny shrimp-like creatures in vast swarms. The base of the ocean food web."
},
"plankton": {
"topic": "Reef & Marine Life",
"definition": "Drifting microscopic ocean life. The foundation of marine food chains."
},
"coral": {
"topic": "Reef & Marine Life",
"definition": "Tiny animals that build vast reef structures. The architects of tropical reefs."
},
"anemone": {
"topic": "Reef & Marine Life",
"definition": "A flower-like, stinging sea creature. Home to clownfish."
},
"starfish": {
"topic": "Reef & Marine Life",
"definition": "A five-armed seabed creature. Can regenerate lost limbs."
},
"jellyfish": {
"topic": "Reef & Marine Life",
"definition": "A drifting, gelatinous creature with stinging tentacles. Pulses through open water."
},
"mantis shrimp": {
"topic": "Reef & Marine Life",
"definition": "A small crustacean with a lightning-fast punch. Has remarkable eyesight."
},
"sponge": {
"topic": "Reef & Marine Life",
"definition": "A simple filter-feeding sea animal. Anchors to the reef."
},
"caviar": {
"topic": "Fish Products",
"definition": "Salt-cured fish eggs, traditionally from sturgeon. A luxury delicacy."
},
"roe": {
"topic": "Fish Products",
"definition": "The eggs of fish. Eaten in many cuisines worldwide."
},
"ikura": {
"topic": "Fish Products",
"definition": "Cured salmon roe used in sushi. Large, glossy orange eggs."
},
"tobiko": {
"topic": "Fish Products",
"definition": "Tiny, crunchy flying-fish roe. A colorful sushi garnish."
},
"lox": {
"topic": "Fish Products",
"definition": "Salt-cured salmon, classically served on bagels. A deli staple."
},
"gravlax": {
"topic": "Fish Products",
"definition": "Salmon cured with salt, sugar, and dill. A Nordic delicacy."
},
"kipper": {
"topic": "Fish Products",
"definition": "A herring that is split, salted, and smoked. A traditional breakfast fish."
},
"bottarga": {
"topic": "Fish Products",
"definition": "Salted, dried fish roe, grated over dishes. A Mediterranean delicacy."
}
};

// Resolve {word, topic, definition} for a "Project <Word> [n]" code name.
export function getNameMeta(name) {
  if (!name) return { word: '', topic: '', definition: '' };
  let base = name.startsWith('Project ') ? name.slice(8) : name;
  base = base.replace(/\s+\d+$/, '').trim();
  const meta = NAME_META[base.toLowerCase()];
  if (meta) return { word: base, topic: meta.topic, definition: meta.definition };
  return { word: base, topic: '', definition: '' };
}
